import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';
const IconCloseThin = (props) => {
  const { color, size } = props;
  const colorCode = colorLookup(color) ?? colorLookup('blue');

  let height;
  let width;

  switch (size) {
    case 'small':
      width = height = 14;
      break;
    case 'medium':
      width = height = 22;
      break;
    case 'large':
      width = height = 28;
      break;
    default:
      width = height = 28;
      break;
  }

  return (
    <SVG width={width} height={height} viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 12.4999C10.3137 12.4999 13 9.81366 13 6.50001C13 3.18636 10.3137 0.500122 7 0.500122C3.68629 0.500122 1 3.18636 1 6.50001C1 9.81366 3.68629 12.4999 7 12.4999Z"
        stroke={colorCode}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.80022 4.69946L5.2002 8.29937" stroke={colorCode} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.2002 4.69946L8.80022 8.29937" stroke={colorCode} strokeLinecap="round" strokeLinejoin="round" />
    </SVG>
  );
};

export { IconCloseThin as default, IconCloseThin };
